import React, { useEffect, useRef, useState } from "react";
import CountUp from "react-countup";
import { skills, skillData } from "../Data/data";
import "react-tabs/style/react-tabs.css";
const About = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const [skillRender, setSkillRender] = useState({
    title: "WebDevelopment",
    name: "web",
  });
  useEffect(() => {
    function onScroll() {
      if (ref.current) {
        const { top, bottom } = ref.current.getBoundingClientRect();
        const isVisible = top < window.innerHeight && bottom >= 0;
        if (isVisible && !visible) {
          setVisible(true);
        }
      }
    }
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [visible]);
  return (
    <div
      id="skills"
      className=" max-w-screen flex flex-col justify-start items-center mt-40 sm:mt-0 py-24 min-h-screen "
    >
      <div className="text-4xl text-blue-500 mt-5 text-center pb-10">
        Skills <div className="bg-blue-300 h-2 w-56 mb-8 sm:mb-0" />
      </div>
      <div className="h-10 w-[50vw] flex sm:flex-row flex-col items-center justify-center">
        {skills.map((items) => (
          <button
            className="focus:scale-[1.2] focus:uppercase px-4 py-1 mx-4 sm:mt-0 mb-4 bg-blue-50 hover:shadow-md shadow-blue-300 duration-500 shadow-sm rounded"
            onClick={() => {
              setSkillRender({ title: items.title, name: items.name });
            }}
          >
            {items.title}
          </button>
        ))}
      </div>
      <div
        className={`bg-blue-300 h-2 w-32 mt-2 shadow-gray-500 shadow-md ml-4 rounded-full hidden sm:block ${
          skillRender.name === "Pro"
            ? `translate-x-[5.4rem]`
            : `-translate-x-[5.4rem]`
        } duration-1000`}
      />

      <div className="md:text-3xl text-xl text-center mt-8 md:mt-4">
        {skillRender.title} Skills :
      </div>
      <div
        ref={ref}
        className="flex flex-wrap sm:mt-0 mt-10  justify-center items-center"
      >
        {skillData
          .filter((item) => {
            return item.title === skillRender.name;
          })
          .map((items) => (
            <p
              id={items.name}
              className="flex items-center justify-center bg-blue-200 shadow-md shadow-blue-300 my-2 md:my-6 h-24 md:h-32 hover:scale-[1.2] hover:-translate-y-1 hover:cursor-pointer duration-[1.3s] px-4 text-4xl mx-5 md:mx-16 rounded-lg font-semibold"
            >
              <div className="flex flex-col md:w-36 w-auto">
                <div className="w-20 text-xl font-extralight text-blue-400 ">
                  {items.name}
                </div>
                {/* <div className="text-base">{items.desc}</div> */}
              </div>
              {visible && (
                <div className="bg-sky-200 p-1 border-4 rounded-md text-xl md:text-4xl md:ml-0 ml-2">
                  <p>
                    <CountUp
                      className=""
                      start={0}
                      end={items.end}
                      duration={2}
                    />
                    %
                  </p>
                  <div className=" py-2 ml-2 text-blue-700 text-2xl md:text-4xl font-extralight">
                    {items.icon}
                  </div>
                </div>
              )}
            </p>
          ))}
      </div>
    </div>
  );
};

export default About;
